import { useOverlay } from '@/common/components/Overlay/Overlay.context';
import { TOverlayChildren } from '@/common/components/Overlay/Overlay.types';

export function OverlayChildren({ children }: { children?: TOverlayChildren }) {
  const { close } = useOverlay();
  return typeof children === 'function' ? children({ close }) : children;
}
